import { createAction, props } from '@ngrx/store';
import { FertilizerFromDelivery } from 'src/app/fertilizers/models/fertilizer.model';

import { ManureSpace, ParamsImportFertilizers } from '../models/manure-space.models';

export const getManureSpace = createAction('[Manure space] Get manure space');

export const setManureSpaceSuccess = createAction(
  '[ManureSpace] Set ManureSpace Success',
  props<{ manureSpace: ManureSpace | null }>(),
);

export const setManureSpaceFailure = createAction(
  '[ManureSpace] Set ManureSpace Failure',
  props<{ error: unknown }>(),
);

export const getManureSpaceByManureCode = createAction(
  '[Manure space] Get filtered manure space by manure code',
);

export const setManureSpaceFilteredByManureCodeSuccess = createAction(
  '[ManureSpace] Set ManureSpace Success Filtered By Manure Code',
  props<{ manureSpace: ManureSpace | null }>(),
);

export const setManureSpaceFilteredByManureCodeFailure = createAction(
  '[ManureSpace] Set ManureSpace Failure Filtered By Manure Code',
  props<{ error: unknown }>(),
);

export const getMineralBalance = createAction(
  '[Manure space] Get mineral balance',
  props<{ importParams: ParamsImportFertilizers }>(),
);

export const getAdvisedFertilizers = createAction(
  '[Manure space] Get advised fertilizers',
  props<{ cropYear: number }>(),
);

export const toggleMineralImport = createAction('[Manure space] Opens the mineral import screen');

export const toggleAdvisedFertilizersImport = createAction(
  '[Manure space] Opens the advised fertilizers import screen',
);

export const toggleAnimalManureTransportImport = createAction(
  '[Manure space] Opens the animal manure transport import screen',
);

export const toggleSewageSludgeCompostTransportImport = createAction(
  '[Manure space] Opens the sewage sludge and compost transport import screen',
);

export const setFertilizersFromDelivery = createAction(
  '[Manure space] Set fertilizers from delivery',
  props<{ fertilizers: FertilizerFromDelivery[] | null }>(),
);

export const setAdvisedFertilizers = createAction(
  '[Manure space] Set advised fertilizers',
  props<{ fertilizers: FertilizerFromDelivery[] | null }>(),
);

export const setManureSpace = createAction(
  '[Manure space] Set manure space',
  props<{ manureSpace: ManureSpace | null }>(),
);

export const setManureSpaceComment = createAction(
  '[Manure space] Set manure space comment',
  props<{ comment: string | null }>(),
);

export const setInitialStockMatchesRvo = createAction(
  '[Manure space] Set initial stock matches RvO',
  props<{ initialStockMatchesRvo: boolean }>(),
);

export const getManureSpaceByPeriod = createAction('[Manure space] Get manure space by period');

export const setManureSpaceByPeriodSuccess = createAction(
  '[ManureSpace] Set ManureSpace By Period Success',
  props<{ manureSpace: ManureSpace | null }>(),
);

export const setManureSpaceByPeriodFailure = createAction(
  '[ManureSpace] Set ManureSpace By Period Failure',
  props<{ error: unknown }>(),
);

export const resetManureData = createAction('[ManureSpace] Reset Manure Data');

export const setActiveTab = createAction(
  '[ManureSpace] Set Active Tab',
  props<{ tabIndex: number }>(),
);
